import React, { Component, PropTypes } from 'react';
import StandardImage from '../../shared/StandardImage';
import PersonDetailStickyHeader from './StickyHeader';
import TextSlider from '../../shared/TextSlider';
import PersonDetailBio from './Bio';
import PersonDetailObjectList from './ObjectList';
import Toolbar from '../../shared/Toolbar'
import SocialShare from '../../shared/SocialShare';
import settings from '../../../../config/settings';
import { personSubTitle } from '../../../common';
import { getCurrentLanguage, addToMyCollection } from '../../../localData';

class PersonDetail extends Component {
    static propTypes = {
        store: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        routeParams: PropTypes.object.isRequired,
    };

    componentWillMount() {
        this.setState({
            showSocialShare: false
        });
    }

    addToMyCollectionDesigners = () => {
        const id = this.props.store.person.id;
        addToMyCollection('designers', id);
    };

    addToMyCollectionProducers = () => {
        const id = this.props.store.person.id;
        addToMyCollection('producers', id);
    };

    toggleSocialSharing = () => {
        this.setState({
            showSocialShare: !this.state.showSocialShare
        });
    };

    getShareUrl = () => {
        const path = this.props.route.path
            .replace(':lang', this.props.routeParams.lang)
            .replace(':id', this.props.routeParams.id);

        return `${settings.socialSharing.baseUrl}/#${path}`;
    };

    l = (key) => {
        const str = `${getCurrentLanguage()}.components.PersonDetail.${key}`;
        return localize(str);
    };
    
    render() {
        const { store, relay } = this.props;
        const person = store.person;

        let headerClass = "detail-header detail-section-content-heading detail-section-content";
        headerClass += !!person.PerStandardImage ? '' : ' no-standard-image';

        return (
            <div className='person'>
                <PersonDetailStickyHeader
                    relay={ relay }
                    person={person}
                    imageUrl={person.PerThumbnail}
                    title={person.PerNameTxt}
                    txt={personSubTitle(person)}
                />
                {
                    person.PerStandardImage &&
                    <StandardImage imageUrl={ person.PerStandardImage } isFullWidth={true} />
                }
                <header id="detailHeader" className={ headerClass }>
                    <div className="content-box">
                        <TextSlider>
                            <h1>
                                { person.PerNameTxt }
                            </h1>
                        </TextSlider>
                    </div>
                    <div className="content-box">
                        <p className="h1 artist">
                            { personSubTitle(person) }
                        </p>
                    </div>
                </header>
                {
                    !this.state.showSocialShare &&
                    <div className="detail-body">
                        <Toolbar handleAddToMyCollection={
                            person.PerTypeVoc === 'Designer' ?
                                this.addToMyCollectionDesigners :
                                this.addToMyCollectionProducers
                        }
                                 handleSharing={ this.toggleSocialSharing }
                        />
                        <PersonDetailBio person={person} />
                        {
                            person.PerObjectsCount > 0 &&
                            <PersonDetailObjectList person={person} />
                        }
                    </div>
                }
                {
                    this.state.showSocialShare &&
                    <SocialShare
                        lang={ getCurrentLanguage() }
                        title={ person.PerNameTxt }
                        url={ this.getShareUrl() }
                        onClose={ this.toggleSocialSharing }
                    />
                }
            </div>
        );
    }
}

export default PersonDetail;


// WEBPACK FOOTER //
// ./app/components/Person/Detail/PersonDetail.jsx